import React from 'react';
import $ from 'jquery';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import _ from 'underscore';
import queryString from 'query-string';
import { CivilDate } from 'tc39-proposal-temporal';
import { findSelectedNode } from '@bingads-webui-campaign-react/with-site-map';
import { components, LayoutContext } from '@bingads-webui-react/app-layout-container';
import { COPILOT_WIDTH } from '@bingads-webui-campaign-react/shell-ui-common';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { withI18nConsumer } from '@bingads-webui-react/i18n-context';
import { withGlobalFilter } from '@bingads-webui-campaign-react/global-filter-context';
import { WaterfallFilterType } from '@bingads-webui-campaign/filter-storage';
import { QueryParam, withScope } from '@bingads-webui-react/scope-service';
import { RANGES } from '@bingads-webui-react/compared-date-range-picker';
import { withResponsiveSize } from '@bingads-webui-react/with-responsive-size';
import { withPageReady } from '@bingads-webui-react/with-page-ready';
import { withActivityContext } from '@bingads-webui-react/hoc-with-signal';
import DisabledDatePicker from './components/disabled-date-picker';
import { StyledTabBar } from './components/tab-bar';
import { getSubPageMenuStyles } from './styles/sub-page-menu-styles';
import { DatePickerWithScope } from './components/date-picker';
import { HistoryButton } from './components/history-button';
import { AutoApplyButton } from './components/auto-apply-button';
import { getPathNameOfSubPageItem } from './common/router-helper';

const getSelectedItemsFromMap = items => _.find(items, item => item.selected);
const getAvailableItemsFromMap = items => _.filter(items, item => item.available);
const subPageMenuTabFont = '600 18px Segoe UI';
const paddingLeft = 8;
const paddingRight = 8;
const marginRight = 8;
const subPageMenuTabSpaceBetween = paddingLeft + paddingRight + marginRight;

class SubPageMenuInternal extends React.Component {
  static defaultProps = {
    showDatePicker: true,
    showDisabledDatePicker: false,
    singleTabMode: false,
    initialResetLayout: true,
    forceResetLayout: false,
    showHistoryButton: false,
    showDownloadButton: false,
    showAutoApplyButton: false,
    getTabItems: _.identity,
    disableCompare: false,
    onTabItemRender: null,
    renderExtraContent: () => null,
    renderDownloadButton: () => null,
    minDate: null,
    selectedParent: '',
    activity: { signal: _.noop },
  };

  constructor(props) {
    super(props);

    this.state = {
      fallBackTabItem: null,
      SubPageMenuResponsiveSizes: [],
      subMenuClassName: '',
      pickerContainerPartClassName: '',
      tabBarPreFixClassName: '',
      datePickerWidth: 0,
    };
    if (props.initialResetLayout) {
      this.resetLayout(true);
    }
    this.ResponsiveTabBar = StyledTabBar;
    this.canvas = document.createElement('canvas');
  }

  componentDidMount() {
    this.getResponsiveTabBar();
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (this.props.siteMap !== nextProps.siteMap) {
      this.ResponsiveTabBar = StyledTabBar;
    }

    if (nextProps.scope !== this.props.scope
      || nextProps.serverContext !== this.props.serverContext
      || nextProps.showDatePicker !== this.props.showDatePicker
      || nextProps.showDisabledDatePicker !== this.props.showDisabledDatePicker
      || nextProps.disableCompare !== this.props.disableCompare
      || nextProps.showHistoryButton !== this.props.showHistoryButton
      || nextProps.showAutoApplyButton !== this.props.showAutoApplyButton
      || nextProps.showDownloadButton !== this.props.showDownloadButton
      || nextProps.siteMap !== this.props.siteMap
      || nextState.SubPageMenuResponsiveSizes !== this.state.SubPageMenuResponsiveSizes
      || nextState.fallBackTabItem !== this.state.fallBackTabItem
      || nextProps.mode !== this.props.mode
      || nextState.subMenuClassName !== this.state.subMenuClassName
      || nextState.pickerContainerPartClassName !== this.state.pickerContainerPartClassName
      || nextState.tabBarPreFixClassName !== this.state.tabBarPreFixClassName
      || nextState.datePickerWidth !== this.state.datePickerWidth
      || nextProps.singleTabMode !== this.props.singleTabMode
      || this.getIsCopilotExpanded(nextProps) !== this.getIsCopilotExpanded(this.props)
    ) {
      return true;
    }
    return false;
  }

  componentDidUpdate(prevProps) {
    if (this.props.siteMap !== prevProps.siteMap || this.getIsCopilotExpanded(prevProps) !== this.getIsCopilotExpanded(this.props) || this.props.singleTabMode !== prevProps.singleTabMode) {
      this.getResponsiveTabBar();
    }

    if (prevProps.showDisabledDatePicker !== this.props.showDisabledDatePicker
      || prevProps.showDatePicker !== this.props.showDatePicker
      || prevProps.disableCompare !== this.props.disableCompare
      || prevProps.mode !== this.props.mode
      || this.props.forceResetLayout) {
      this.resetLayout();
    }
  }

  onSelect = (selectedKey) => {
    const { activity } = this.props;
    activity.signal(`sub page menu item clicked, name: ${selectedKey}`);

    if (!this.selectedTabItem || selectedKey !== this.selectedTabItem.id) {
      const [clickedTabItem] = _.filter(this.tabItems, item => item.id === selectedKey);
      if (clickedTabItem.available) {
        this.setState({ fallBackTabItem: null });
        const pathname = getPathNameOfSubPageItem(clickedTabItem);
        let { search } = this.props.scope.history.location;
        if (pathname.includes('vnext/recommendations')) {
          search = queryString.parse(search);
          search = _.omit(search, 'recommendationType');
          search = queryString.stringify(search);
        }
        this.props.scope.history.push({
          pathname,
          search,
        });
      } else {
        this.setState({ fallBackTabItem: clickedTabItem });
      }
    } else {
      this.setState({ fallBackTabItem: null });
    }
  };

  onSwitchCompare = ({ isChecked }) => {
    if (isChecked) {
      this.props.changeLayout({ tab: { mode: 'expanded' } });
      this.setClassName('expanded');
    } else {
      this.props.changeLayout({ tab: { mode: 'collapsed' } });
      this.setClassName('collapsed');
    }
  };

  getTextWidth = (text) => {
    const context = this.canvas.getContext('2d');
    context.font = subPageMenuTabFont;
    const metrics = context.measureText(text);
    return metrics.width;
  };

  getIsCopilotExpanded(props) {
    const isCopilotExpanded = _.chain(props).result('layoutConfig').result('copilot').result('mode')
      .value() === 'expanded';
    return isCopilotExpanded;
  }

  getResponsiveTabBar() {
    const isCopilotExpanded = this.getIsCopilotExpanded(this.props);
    const SubPageMenuResponsiveSizes = [];
    let currentMinWidth = 100;
    for (let i = 0; i < this.tabItems.length; i += 1) {
      const currentItemWidth = this.getTextWidth(this.props.i18n.getString(this.tabItems[i].name));
      SubPageMenuResponsiveSizes.push({
        name: i + 1,
        minWidth: currentMinWidth + currentItemWidth + subPageMenuTabSpaceBetween + (isCopilotExpanded ? COPILOT_WIDTH : 0),
      });
      currentMinWidth += (currentItemWidth + subPageMenuTabSpaceBetween);
    }
    this.setState({ SubPageMenuResponsiveSizes }); //eslint-disable-line
    this.ResponsiveTabBar = this.tabItems.length > 0 && SubPageMenuResponsiveSizes.length > 0 ?
      withResponsiveSize(StyledTabBar, SubPageMenuResponsiveSizes) : StyledTabBar;
  }

  setClassName = (mode, init) => {
    let subMenuClassNamePrefix;
    if (mode === 'expanded') {
      subMenuClassNamePrefix = classNames('bingads-campaign-react-sub-page-menu', 'expanded');
    } else {
      subMenuClassNamePrefix = classNames('bingads-campaign-react-sub-page-menu', 'collapsed');
    }
    const subMenuClassName = classNames([this.props.classes.container, subMenuClassNamePrefix]);
    const pickerContainerPartClassName = classNames([this.props.classes.pickerContainer, subMenuClassNamePrefix]
      .concat(this.isImprovedDateRangePickerEnabled() ? [this.props.classes.pickerQuickContainer] : []));
    const tabBarPreFixClassName = mode;
    if (init) {
      this.state.subMenuClassName = subMenuClassName;
      this.state.pickerContainerPartClassName = pickerContainerPartClassName;
      this.state.tabBarPreFixClassName = tabBarPreFixClassName;
    } else {
      this.setState({
        subMenuClassName,
        pickerContainerPartClassName,
        tabBarPreFixClassName,
      });
    }
  };

  getOffset = (navMode, menuMode) => (components.nav[navMode].width || 0) + (components.menu[menuMode].width || 0);

  isImprovedDateRangePickerEnabled() {
    return this.props.serverContext.DynamicPermissions && this.props.serverContext.DynamicPermissions.ImprovedDateFilter;
  }

  handleClose = () => {
    this.setState({ fallBackTabItem: null });
  };

  updateDatePickerWidth = (newWidth) => {
    if (this.state.datePickerWidth !== newWidth && newWidth > 0) {
      this.setState({ datePickerWidth: newWidth });
    }
  };

  resetLayout = (init) => {
    if (this.props.mode !== 'hidden') {
      if (this.props.showDatePicker
        && this.props[WaterfallFilterType.DateFilter]
        && this.props[WaterfallFilterType.DateFilter].compared
        && !this.props.disableCompare
      ) {
        this.props.changeLayout({ tab: { mode: 'expanded' } });
        this.setClassName('expanded', init);
      } else {
        this.props.changeLayout({ tab: { mode: 'collapsed' } });
        this.setClassName('collapsed', init);
      }
    }
  };

  // Date picker need some initialization from parent components, which is not available for lazy load async
  renderDatePicker = () => {
    const {
      minDate,
    } = this.props;
    const civilMinDate = minDate ? new CivilDate(minDate.year, minDate.month, minDate.day) : minDate;

    const DatePickerWithPageReady = withPageReady(() => (
      <div className={this.state.pickerContainerPartClassName}>
        <DatePickerWithScope
          i18n={this.props.i18n}
          lcid={this.props.serverContext.CurrentUser.LocaleID}
          timeZone={this.props.serverContext.CurrentAccount.TimeZone}
          dateFormat={this.props.serverContext.CurrentUser.CultureDateTimeFormat.ShortDatePattern}
          dateFilter={this.props[WaterfallFilterType.DateFilter]}
          onSwitchCompare={this.onSwitchCompare}
          disableCompare={this.props.disableCompare}
          updateWaterfallFilter={data => this.props.updateWaterfallFilter({
            filterType: WaterfallFilterType.DateFilter,
            filter: data,
          })}
          serverContext={this.props.serverContext}
          {...(this.props.location.pathname === '/campaign/vnext/uettag' || this.props.location.pathname === '/campaign/vnext/uettaginsights' ? {
            rangeIds: [
              RANGES.Custom,
              RANGES.Today,
              RANGES.Yesterday,
              RANGES.ThisWeek,
              RANGES.ThisWeekMon,
              RANGES.Last7Days,
              RANGES.LastWeek,
              RANGES.LastWeekMon,
              RANGES.Last14Days,
              RANGES.ThisMonth,
              RANGES.LastMonth,
              RANGES.Last30Days,
              RANGES.Last3Months,
              RANGES.Last6Months,
              RANGES.EntireTime,
            ],
          } : {})}
          minDate={civilMinDate}
        />
      </div>
    ), null);

    return (<DatePickerWithPageReady />);
  };

  renderDisabledDatePicker = () => {
    const DisabledDatePickerWithPageReady = withPageReady(() => (
      <div className={this.state.pickerContainerPartClassName}>
        <DisabledDatePicker />
      </div>
    ), null);

    return (<DisabledDatePickerWithPageReady />);
  };

  renderHistoryButton = () => (
    <div
      className={classNames(
        this.state.pickerContainerPartClassName,
        (this.props.showDownloadButton || this.props.showAutoApplyButton) && 'with-left-margin'
      )}
    >
      <HistoryButton />
    </div>
  );

  renderDownloadButton = () => (
    <div className={classNames(this.state.pickerContainerPartClassName, this.props.showAutoApplyButton && 'with-left-margin')}>
      {this.props.renderDownloadButton(true)}
    </div>
  );

  renderAutoApplyButton = () => (
    <div className={classNames(this.state.pickerContainerPartClassName)}>
      <AutoApplyButton />
    </div>
  );

  render() {
    this.tabItems = [];
    if (this.props.singleTabMode) {
      const selectedleafItem = findSelectedNode(this.props.siteMap);
      if (selectedleafItem) {
        this.tabItems = [selectedleafItem];
      }
    } else {
      this.selectedPageMenu = getSelectedItemsFromMap(this.props.siteMap);
      if (this.selectedPageMenu) {
        this.tabItems = this.selectedPageMenu.children;
      }
    }

    const { getTabItems } = this.props;
    this.tabItems = getTabItems(this.tabItems);

    // in the case singleTabMode is set
    // both selectedTabItem and availableTabItems would be the selected leaf item
    this.selectedTabItem = getSelectedItemsFromMap(this.tabItems);
    this.availableTabItems = getAvailableItemsFromMap(this.tabItems);
    const datePickerShowOrHideClass = this.props.showDatePicker ? 'datePickerShow' : 'datePickerHide';
    const disabledDatePickerShowOrHideClass = this.props.showDisabledDatePicker ? 'disabledDatePickerShow' : 'disabledDatePickerHide';
    const currDatePickerWidth = $('.compared-date-range-picker button')[0] ? $('.compared-date-range-picker button')[0].clientWidth + 10 : 0;
    this.updateDatePickerWidth(currDatePickerWidth);
    const datePickerOffset = this.props.showDatePicker ? this.state.datePickerWidth : 0;
    const disabledDatePickerOffset = this.props.showDisabledDatePicker ? this.state.datePickerWidth : 0;
    const AutoApplyButtonWidth = this.props.showAutoApplyButton && $('.recommendation-auto-apply-item')[0] ?
      $('.recommendation-auto-apply-item')[0].clientWidth + 10 : 0;
    const AutoApplyButtonOffset = this.props.showAutoApplyButton ? AutoApplyButtonWidth : 0;
    const historyButtonWidth = this.props.showHistoryButton && $('.recommendation-history-item')[0] ?
      $('.recommendation-history-item')[0].clientWidth + 10 : 0;
    const historyButtonOffset = this.props.showHistoryButton ? historyButtonWidth : 0;
    const downloadButtonWidth = this.props.showDownloadButton && $('.recommendation-download-button')[0] ?
      $('.recommendation-download-button')[0].clientWidth + 10 : 0;
    const downloadButtonOffset = this.props.showDownloadButton ? downloadButtonWidth : 0;
    const layout = { config: this.props.layoutConfig };

    return (
      <React.Fragment>
        <nav className={this.state.subMenuClassName} aria-label="Sub page menu">
          <this.ResponsiveTabBar
            className={classNames(this.state.tabBarPreFixClassName, datePickerShowOrHideClass, disabledDatePickerShowOrHideClass, this.props.selectedParent)}
            tabItems={this.tabItems}
            i18n={this.props.i18n}
            offset={
                  this.getOffset(layout.config.nav.mode, layout.config.menu.mode) +
                  datePickerOffset +
                  disabledDatePickerOffset +
                  AutoApplyButtonOffset +
                  historyButtonOffset +
                  downloadButtonOffset
                }
            selectedTabItem={this.selectedTabItem}
            fallBackTabItem={this.state.fallBackTabItem}
            availableTabItems={this.availableTabItems}
            onSelect={this.onSelect}
            handleClose={this.handleClose}
            onTabItemRender={this.props.onTabItemRender}
            renderExtraContent={this.props.renderExtraContent}
          />
          {this.tabItems.length !== 0 && this.props.showDatePicker &&
                this.renderDatePicker()}
          {this.tabItems.length !== 0 && this.props.showDisabledDatePicker &&
                this.renderDisabledDatePicker()}
          {this.tabItems.length !== 0 && this.props.showAutoApplyButton &&
                this.renderAutoApplyButton()}
          {this.tabItems.length !== 0 && this.props.showDownloadButton &&
                this.renderDownloadButton()}
          {this.tabItems.length !== 0 && this.props.showHistoryButton &&
                this.renderHistoryButton()}
        </nav>
        <div className={classNames([this.props.classes.subMenuSeperator])} />
      </React.Fragment>
    );
  }
}

SubPageMenuInternal.propTypes = {
  classes: PropTypes.shape(_.mapObject(
    getSubPageMenuStyles({}, {}),
    _.constant(PropTypes.string.isRequired)
  )).isRequired,
  scope: PropTypes.instanceOf(QueryParam).isRequired,
  updateWaterfallFilter: PropTypes.func.isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  changeLayout: PropTypes.func.isRequired,
  serverContext: PropTypes.shape({
    CurrentAccount: PropTypes.object.isRequired,
    CurrentCustomer: PropTypes.object.isRequired,
    CurrentUser: PropTypes.object.isRequired,
    DynamicPermissions: PropTypes.object.isRequired,
  }).isRequired,
  showDatePicker: PropTypes.bool,
  showDisabledDatePicker: PropTypes.bool,
  showHistoryButton: PropTypes.bool,
  showAutoApplyButton: PropTypes.bool,
  showDownloadButton: PropTypes.bool,
  siteMap: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
  })).isRequired,
  mode: PropTypes.string.isRequired,
  singleTabMode: PropTypes.bool,
  initialResetLayout: PropTypes.bool,
  forceResetLayout: PropTypes.bool,
  getTabItems: PropTypes.func,
  disableCompare: PropTypes.bool,
  onTabItemRender: PropTypes.func,
  renderExtraContent: PropTypes.func,
  renderDownloadButton: PropTypes.func,
  minDate: PropTypes.shape({
    year: PropTypes.number,
    month: PropTypes.number,
    day: PropTypes.number,
  }),
  selectedParent: PropTypes.string,
  activity: PropTypes.shape({
    signal: PropTypes.func.isRequired,
    trace: PropTypes.func.isRequired,
  }),
  layoutConfig: PropTypes.shape({
    copilot: PropTypes.shape({
      mode: PropTypes.string,
    }),
  }).isRequired,
  permissions: PropTypes.shape({ dynamic: PropTypes.shape({}) }).isRequired,
};

const SubpageMenuInternalWithStyle = withDefaultStyles(SubPageMenuInternal, getSubPageMenuStyles);

const SubPageMenu = props => (
  <LayoutContext.Consumer>
    {({ config, change }) => (<SubpageMenuInternalWithStyle changeLayout={change} layoutConfig={config} {...props} />)}
  </LayoutContext.Consumer>
);

export const StyledSubPageMenu =
  withActivityContext(withGlobalFilter(withScope(withI18nConsumer(SubPageMenu))));
